import { baseUrl } from '@/config/constants';

interface IFetchAvailability {
  tourId: string;
  adults: number;
  children: number;
  month: number;
  year: number;
}

type TDayTime = {
  day: number;
  time: Array<string>;
};

export const fetchAvailability = async ({
  tourId,
  adults,
  children,
  month,
  year,
}: IFetchAvailability): Promise<Array<TDayTime>> => {
  const visitors = adults + children;
  const url = `${baseUrl}/tour/availability/${tourId}/${visitors}/${month}/${year}`;
  const response = await fetch(url);
  const data = await response.json();

  if (!response.ok) {
    throw new Error('Error fetching availability data');
  }
  return data.dayTimes || [];
};
